<div [@routerTransition]>
  <div class="m-subheader">
    <div class="row align-items-center">
      <div class="mr-auto col-auto">
        <h3 class="m-subheader__title m-subheader__title--separator">
          <span>{{ 'Notifications' | localize }}</span>
        </h3>
        <span class="m-section__sub">
          {{ 'NotificationsHeaderInfo' | localize }}
        </span>
      </div>
      <div class="col text-right mt-3 mt-md-0">
        <button class="btn btn-success" (click)="openNotificationSettingsModal()">
          <i class="fa fa-cog"></i> {{ 'NotificationSettings' | localize }}
        </button>
        <button class="btn btn-primary" (click)="setAllNotificationsAsRead()">
          <i class="fa fa-check"></i> {{ 'SetAllAsRead' | localize }}
        </button>
      </div>
    </div>
  </div>
  <div class="m-content">
    <div class="m-portlet m-portlet--mobile">
      <div class="m-portlet__body">
        <div class="m-form m-form--label-align-right">
          <form autocomplete="off">
            <div class="form-body">
              <div class="row m--margin-bottom-10">
                <div class="col-xl-12">
                  <label>{{ 'Status' | localize }}</label>
                  <div class="input-group">
                    <select #TargetValueFilterSelectionCombobox class="form-control" [(ngModel)]="readStateFilter"
                      name="readStateFilter">
                      <option value="ALL">{{ 'All' | localize }}</option>
                      <option value="UNREAD">{{ 'Unread' | localize }}</option>
                    </select>
                    <span class="input-group-btn">
                      <button class="btn btn-primary" type="button" (click)="getNotifications()">
                        <i class="flaticon-search-1" [attr.aria-label]="l('Search')"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="align-items-center">
          <div class="primeng-datatable-container" [busyIf]="dataTableHelper.isLoading">
            <p-table #dataTable (onLazyLoad)="getNotifications($event)" [value]="dataTableHelper.records"
              rows="{{ dataTableHelper.defaultRecordsCountPerPage }}" [lazy]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 80px">{{ 'Actions' | localize }}</th>
                  <th>
                    {{ 'Notification' | localize }}
                  </th>
                  <th pSortableColumn="creationTime" style="width: 160px">
                    {{ 'NotificationTime' | localize }}
                    <p-sortIcon field="creationTime"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-record="$implicit">
                <tr>
                  <td>
                    <div class="btn-group dropdown" dropdown>
                      <button dropdownToggle class="dropdown-toggle btn btn-sm btn-primary">
                        <i class="fa fa-cog"></i><span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu" *dropdownMenu>
                        <li *ngIf="!isRead(record)">
                          <a href="javascript:;" (click)="setAsRead(record)">{{ 'SetAsRead' | localize }}</a>
                        </li>
                        <li>
                          <a href="javascript:;" (click)="deleteNotification(record)">{{ 'Delete' | localize }}</a>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td>
                    <span [ngClass]="{ 'text-bold': !isRead(record) }"
                      title="{{ record.formattedNotification.text }}">{{
                      record.formattedNotification.text
                      }}</span>
                  </td>
                  <td>
                    <span title="{{ record.notification.creationTime | momentFormat: 'llll' }}">
                      {{ fromNow(record.notification.creationTime) }}
                    </span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="primeng-no-data" *ngIf="dataTableHelper.totalRecordsCount == 0">
              {{ 'NoData' | localize }}
            </div>
            <div class="primeng-paging-container">
              <p-paginator [rows]="dataTableHelper.defaultRecordsCountPerPage" #paginator
                (onPageChange)="getNotifications($event)" [totalRecords]="dataTableHelper.totalRecordsCount"
                [rowsPerPageOptions]="dataTableHelper.predefinedRecordsCountPerPage">
              </p-paginator>
              <span class="total-records-count">
                {{ 'TotalRecordsCount' | localize: dataTableHelper.totalRecordsCount }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
